module.exports = __webpack_public_path__ + "media/images/teams/TORINO-bae1a7e96e77f3e5d02a9e09e18fd30e.png";